<!--
   Created by Terence on 2024/3/7 - 17:13
-->
<template>
  <div class="pinfo">
    <div class="pinfo-values" v-if="isBuyoutType">
      <div class="pinfo-values-left">
        <span class="price">
          <span class="price-suffix">¥</span>
          <span class="price-value">
            {{ buyoutDetailData.product?.price }}
          </span>
        </span>
        <span class="count">
          <span class="count-label">库存</span>
          <span class="count-value">
            &nbsp;{{ buyoutDetailData.product?.stock }}
          </span>
        </span>
      </div>
      <div class="pinfo-values-right">
        <span class="count">
          <span class="count-label">卖出</span>
          <span class="count-value">
            &nbsp;{{ buyoutDetailData.otherDetail?.sellCount }}
          </span>
        </span>
        <span class="splitline" />
        <span class="count">
          <span class="count-label">收藏</span>
          <span class="count-value">
            &nbsp;{{ buyoutDetailData.otherDetail?.favoriteCount }}
          </span>
        </span>
      </div>
    </div>
    <div class="pinfo-values" v-else>
      <div class="pinfo-values-left">
        <span class="auction-tag" v-if="type === 'BLIND'">暗拍</span>
        {{ priceLabel }}&nbsp;
        <span class="price">
          <span class="price-suffix">¥</span>
          <span class="price-value">{{ displayPrice }}</span>
        </span>
        <!-- 暗拍时显示起拍价 -->
        <span
          class="starting-price"
          v-if="type === 'BLIND' && !isEnded && !isFuture"
        >
          <span>(</span>
          <span class="starting-price-value"
            >¥{{ auctionDetailData?.startingPrice }}</span
          >
          <span>起拍</span>
          <span>)</span>
        </span>
      </div>
      <div class="pinfo-values-right">
        <span class="count">
          <span class="count-label">订阅</span>
          <span class="count-value">
            &nbsp;{{ auctionDetailData.followCount }}
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, inject, watch, computed } from "vue";
import TokenPreviewSection from "./TokenPreviewSection";
// import TokenNumber from "./TokenNumber.vue";
import { useElementVisibility } from "@/hooks/useElementVisibility";
import { DuTag } from "dangoui";

const detailData = inject("detailData");
const buyoutDetailData = inject("buyoutDetailData");
const auctionDetailData = inject("auctionDetailData");
// const tradeType = inject("tradeType");
const isBuyoutType = inject("isBuyoutType");
const bigTokenNoRef = inject("bigTokenNoRef");
const type = computed(() => {
  return auctionDetailData.value?.type;
});

// 拍卖状态判断
const status = computed(() => auctionDetailData.value?.status);
const isFuture = computed(() => status.value === 6); // 未开始
const isEnded = computed(() => [2, 3, 4, 5].includes(status.value)); // 已结束
const isSuccess = computed(() => [3, 4].includes(status.value)); // 成交

// 价格标签
const priceLabel = computed(() => {
  if (isSuccess.value) {
    return "成交价";
  }
  if (type.value === "BLIND") {
    return isFuture.value ? "起拍价" : "当前价";
  }
  return auctionDetailData.value?.currentPrice ? "当前价" : "起拍价";
});

// 显示价格
const displayPrice = computed(() => {
  const { startingPrice, currentPrice, hammerPrice } =
    auctionDetailData.value || {};

  // 成交时显示成交价
  if (isSuccess.value) {
    return type.value === "BLIND" ? "???" : hammerPrice;
  }

  // 暗拍逻辑
  if (type.value === "BLIND") {
    return isFuture.value ? startingPrice : "???";
  }

  // 普通拍卖
  return currentPrice > startingPrice ? currentPrice : startingPrice;
});

// const bigTokenNoRef = ref();
const { isElementVisible } = useElementVisibility(bigTokenNoRef);
</script>

<style lang="scss" scoped>
.pinfo {
  //border-radius: 32rpx;
  //overflow: hidden;
  &-values {
    display: flex;
    align-items: center;
    justify-content: space-between;
    &-left {
      display: flex;
      align-items: center;
      .price {
        margin-right: 16rpx;
        display: flex;
        align-items: baseline;
        &-suffix {
          color: var(---color_third, #ff8c42);
          font-family: "Roboto";
          font-size: 36rpx;
          font-style: normal;
          font-weight: 700;
          line-height: 50rpx; /* 138.889% */
        }
        &-value {
          margin-left: 4rpx;
          color: var(---color_third, #ff8c42);
          font-family: "Roboto";
          font-size: 48rpx;
          font-style: normal;
          font-weight: 700;
          line-height: 64rpx; /* 133.333% */
        }
      }
    }
    &-right {
      display: flex;
      align-items: center;
    }
    .count {
      color: var(---text_third, rgba(0, 0, 0, 0.5));
      font-size: 24rpx;
      font-style: normal;
      font-weight: 400;
      line-height: 36rpx; /* 150% */
      white-space: nowrap;
      &-label,
      &-value {
        display: inline-block;
      }
    }
  }
  &-desc {
    margin-top: 24rpx;
    &-value {
      color: var(---text_secondary, rgba(0, 0, 0, 0.7));
      font-size: 28rpx;
      font-style: normal;
      font-weight: 400;
      line-height: 44rpx; /* 157.143% */
    }
  }

  .splitline {
    display: inline-block;
    margin: 0 16rpx;
    width: 2rpx;
    height: 24rpx;
    background-color: rgba(0, 0, 0, 0.1);
  }

  .auction-tag {
    display: flex;
    height: 30rpx;
    min-width: 30rpx;
    padding: 4rpx 6rpx;
    justify-content: center;
    align-items: center;
    gap: 4rpx;
    border-radius: var(--Radius-Small, 8rpx);
    border: 2rpx solid var(--transBlack-border, rgba(0, 0, 0, 0.24));
    background: var(--transBlack-solidBg, rgba(0, 0, 0, 0.88));
    color: #fff;
    font-size: 22rpx;
    margin-right: 8rpx;
  }

  .starting-price {
    display: flex;
    align-items: center;
    color: rgba(0, 0, 0, 0.64);
    font-size: 24rpx;
    margin-left: 8rpx;
    &-value {
      font-family: "Roboto";
    }
  }
}
</style>
